/*LIBRARY*/
import { connect } from "react-redux";

/*COMPONENT*/
import { Draggable } from "../reuseable";
import LEGEND_TEXT from "./LEGEND_TEXT";
import LEGEND_NUMBER_STEP from "./LEGEND_NUMBER_STEP";

/*REDUX*/
import {
  filter_isi_layer,
  reset_filter,
  undo_filter_isi_layer,
} from "../../App/actions/dataActions";
import { set_value_properties } from "../../App/actions/propertiesActions";

/*PICTURE*/

/*FUNCTION*/
import is_not_empty from "../../App/validation/is_not_empty";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const LEGEND_PARENT = ({
  auth,
  layer,
  properties,
  filter_isi_layer,
  reset_filter,
  undo_filter_isi_layer,
  set_value_properties,
}) => {
  //local storage
  const language = localStorage?.language || auth.language;

  //local state

  //global props
  const { legend_status, is_mobile } = properties;
  const { geo_layer_list, layer_id } = layer;

  const on_filter_isi_layer = (field_key, value, array_value_filter) => {
    const { layer_id } = layer;
    const body = {
      geo_layer_id: layer_id,
      field_key,
      value,
    };
    if (array_value_filter.includes(value)) {
      undo_filter_isi_layer(body);
    } else {
      filter_isi_layer(body);
    }
  };

  const on_reset_filter = () => {
    const { layer_id } = layer;
    const body = { geo_layer_id: layer_id };
    reset_filter(body);
  };

  const toggle_legend = () => {
    set_value_properties({
      key: "legend_status",
      value: !properties.legend_status,
    });
  };

  //content
  const current_layer = geo_layer_list.find(
    (item) => item?.geo_layer?._id === layer_id,
  )?.geo_layer;
  const field_key = current_layer?.valueStyleProps?.selected_column;
  const fields = current_layer?.fields || [];
  let field = fields.find((f) => f.key === field_key);
  let array_value_filter = field?.array_value_filter
    ? field?.array_value_filter
    : [];
  const style_array = current_layer?.style_array || [];
  const default_style_key = current_layer?.default_style_key || "";

  const style_object = style_array.find(
    (item) => item.key === default_style_key,
  );

  let legend_content;

  if (legend_status) {
    let innerContent = null;

    if (style_array.length > 0 && style_object !== undefined) {
      const color_logic = style_object?.color_logic;
      let content;
      switch (color_logic) {
        case "constant":
          content = <>Warna konstant</>;
          break;
        case "use_existing":
          content = <>Dengan kolom warna</>;
          break;
        case "by_text":
          content = <LEGEND_TEXT />;
          break;
        case "by_number_step":
          content = <LEGEND_NUMBER_STEP />;
          break;
        case "by_number_gradient":
          content = <>Angka gradient</>;
          break;
        default:
          break;
      }
      innerContent = (
        <main style={{ minWidth: "200px", marginTop: "10px" }}>{content}</main>
      );
    } else if (
      current_layer?.isGlobalStyle &&
      current_layer?.globalStyleMode === "by_value" &&
      current_layer?.valueStyleProps?.classify_mode === "number"
    ) {
      const range_value = current_layer?.valueStyleProps?.range || [];
      let color_array = current_layer?.valueStyleProps?.color || [];
      color_array = color_array.filter((item) => item !== "#000");

      innerContent = (
        <main>
          <div className="draggable-content">
            <p className="text_bold margin_bottom">
              {dict?.["Numeric Legend"]?.[language]}
            </p>
            <table>
              <tbody>
                {color_array.map((item, idx) => (
                  <tr key={idx}>
                    <td>
                      <div
                        style={{
                          width: "15px",
                          height: "15px",
                          backgroundColor: item,
                        }}
                      />
                    </td>
                    <td className="text_inferior">
                      {range_value?.[idx]?.min} - {range_value?.[idx]?.max}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </main>
      );
    } else if (
      current_layer?.isGlobalStyle &&
      current_layer?.globalStyleMode === "by_value" &&
      current_layer?.valueStyleProps?.classify_mode === "text"
    ) {
      const selected_column = current_layer?.valueStyleProps?.selected_column;
      const range_value = current_layer?.valueStyleProps?.range || [];
      let color_array = current_layer?.valueStyleProps?.color || [];
      color_array = color_array.filter((item) => item !== "#000");

      innerContent = (
        <main>
          <div
            className="draggable-content scroll_y_auto"
            style={{
              maxHeight:
                window.innerHeight > 400
                  ? "calc(100svh - 350px)"
                  : "calc(100svh - 150px)",
            }}
          >
            <button
              className="button_small background_black margin_right"
              onClick={on_reset_filter}
            >
              Clear Filter
            </button>
            <p className="text_small">
              {dict["Reset (restore show all)"][language]}
            </p>
            <p className="text_bold margin_bottom">
              {dict["Textual Legend"][language]}
            </p>
            <table>
              <tbody>
                {color_array.map((item, idx) => {
                  const value = is_not_empty(range_value?.[idx])
                    ? String(range_value?.[idx])
                    : "0";
                  return (
                    <tr
                      key={idx}
                      onClick={() =>
                        on_filter_isi_layer(
                          selected_column,
                          value,
                          array_value_filter,
                        )
                      }
                    >
                      <td>
                        <button
                          className={
                            array_value_filter.includes(value)
                              ? "checklist_active"
                              : "checklist_not"
                          }
                        />
                      </td>
                      <td>
                        <div
                          className="border"
                          style={{
                            width: "15px",
                            height: "15px",
                            backgroundColor: item,
                          }}
                        />
                      </td>
                      <td className="text_inferior">{value}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </main>
      );
    }

    if (innerContent) {
      legend_content = (
        <Draggable
          title={dict["Legend"][language]}
          toggle_close={toggle_legend}
          style={{
            background: "white",
            boxShadow: "3px 3px 5px #afababab, -1px -1px 5px #afababab",
            maxWidth: "221px",
          }}
          initialPosition={{
            x: !is_mobile ? window.innerWidth - 247 - 330 - 5 : 5,
            y: window.innerHeight - 273 - 50,
          }}
        >
          {innerContent}
        </Draggable>
      );
    }
  }

  return <main className="noselect">{legend_content}</main>;
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  properties: state.properties,
});

export default connect(mapStateToProps, {
  filter_isi_layer,
  reset_filter,
  undo_filter_isi_layer,
  set_value_properties,
})(LEGEND_PARENT);
